import React from "react";
import { NavigationLinks, Section } from "../../../components";
import { BannerPages, ConsultaDeSorteios } from "../Sections";
import ImageNavigationLinks from "../../../assets/images/residencial/ilustracao-homem-casa.svg";

const ResultadoDosSorteios = () => {
  return (
    <>
      <BannerPages
        subtitle="Seguro Residencial (simplificado)"
        contentWidth={{
          lg: 12,
          xl: 12,
        }}
      />
      <Section as={ConsultaDeSorteios} sectionName="Resultado dos sorteios" />
      <Section
        as={NavigationLinks}
        sectionName="Ainda podemos te ajudar?"
        sectionTitle="Ainda podemos te ajudar?"
        imgSrc={ImageNavigationLinks}
      />
    </>
  );
};

export default ResultadoDosSorteios;
